import * as React from 'react';
import styled from 'styled-components';
import { Input } from './Input';

interface IProps {
  name: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  value: string | number;
  label?: string;
  type: string;
  readOnly?: boolean;
  style?: React.CSSProperties;
  placeholder?: string;
  error?: string;
  role?: string;
  autocomplete?: string;
}

const Container = styled.div``;
const Label = styled.label`
  display: block;
  padding-bottom: 5px;
`;

const HintText = styled.div``;

const ErrorText = styled.div`
  margin-top: 5px;
  border-radius: 10px;
  padding: 5px 10px;
  background-color: rgba(255, 0, 0, 0.5);
`;

const TextField = ({
  name,
  onChange,
  onBlur,
  value,
  label,
  type,
  readOnly,
  placeholder = '',
  style = {},
  error,
  autocomplete,
  role,
}: IProps): React.ReactElement => {
  const changeHandler = (e: React.FormEvent<HTMLInputElement>): void =>
    onChange(e.currentTarget.value);
  return (
    <Container>
      <Label htmlFor={name}>{label}</Label>
      <Input
        data-testid={name}
        id={name}
        name={name}
        value={value}
        role={role ?? 'textbox'}
        autoComplete={autocomplete}
        readOnly={readOnly}
        type={type}
        onChange={changeHandler}
        onBlur={onBlur}
        placeholder={placeholder}
        style={style}
        error={Boolean(error)}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};
export { TextField };
